import { useEffect } from 'react';
import { useSiteConfig } from '../../context/SiteConfigContext';

const FaviconUpdater = () => {
    const { config } = useSiteConfig();

    useEffect(() => {
        // Use the logo from database configs, falling back to the local favicon-32.png (which is also the real logo)
        const logoUrl = config.logo || '/favicon-32.png';
        const logoWithCacheBuster = `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}v=${new Date().getTime()}`;

        // Update main favicon
        const link = document.getElementById('dynamic-favicon');
        if (link) {
            link.href = logoWithCacheBuster;
            link.type = 'image/png';
        }

        // Update Apple Touch Icon
        const appleLink = document.getElementById('dynamic-apple-icon');
        if (appleLink) {
            appleLink.href = logoWithCacheBuster;
        }

        // Fallback: update any other icon links
        document.querySelectorAll("link[rel~='icon']").forEach(el => {
            if (el.id !== 'dynamic-favicon') {
                el.href = logoWithCacheBuster;
            }
        });
    }, [config.logo]);

    return null; // This component doesn't render anything
};

export default FaviconUpdater;
